/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const IconRepeatingEvent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props}>
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M8.34 2.526c-1.512 0-2.88.613-3.871 1.605-.519.519-1.107 1.222-1.58 1.816h2.715a.684.684 0 0 1 0 1.369H1.499a.684.684 0 0 1-.685-.684V2.526a.684.684 0 1 1 1.369 0v2.118c.412-.501.88-1.042 1.318-1.48A6.842 6.842 0 1 1 1.766 9.9a.684.684 0 1 1 1.315-.38 5.473 5.473 0 1 0 5.26-6.994'
      clipRule='evenodd'
    />
  </svg>
)
